import { useLoaderStore } from '../../stores/components/loader';
import { useEffect } from 'react';

const ProgressBarLoader = ({numberOfDocuments}: {numberOfDocuments: number}) => {
  const {progress, setProgress, isLoadingDocuments} = useLoaderStore();
  
  useEffect(() => {
    // Réinitialiser le progress quand on commence un nouveau chargement
    if (isLoadingDocuments) {
      setProgress(0);
    }
  }, [isLoadingDocuments, setProgress]);

  useEffect(() => {
    if(progress < 100 && isLoadingDocuments && numberOfDocuments > 0 && !isNaN(progress)) {
      
      const progressPerDocument = 100 / numberOfDocuments;
      
      const timeoutId = setTimeout(() => {
        // Calcul du nouveau progress
        const newProgress = Math.min(progress + progressPerDocument, 100);
        setProgress(newProgress);
      }, 800);

      // Retourner la fonction clearTimeout
      return () => clearTimeout(timeoutId);
    }
  }, [progress, numberOfDocuments, isLoadingDocuments, setProgress]);

  return isLoadingDocuments && (
    <div className="mx-auto w-full max-w-md px-4 font-Nunito">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-[11px] font-bold tracking-wider text-slate-400 uppercase">
          Préparation des documents
        </span>
        <span className="text-sm font-bold text-slate-700 tabular-nums">
          {progress.toFixed(0)}%
        </span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200">
        <div
          className="h-full rounded-full bg-dca-blue"
          style={{ width: `${progress}%`, transition: 'width 0.8s ease-in-out' }}
        ></div>
      </div>
    </div>
  )
}

export default ProgressBarLoader;
